export const defaultInfoBarData = {
    dateStart: null,
    dateEnd: null,
    orderBy: '1',
    file: '',
    heading: '',
    subText: '',
    navigationLink: '',
    timeText: '',
}
